import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getToken } from '../../../services/auth';

interface DmftData {
  DMFT: { decayed: number; missing: number; filled: number; score: number };
  dmft: { decayed: number; missing: number; filled: number; score: number };
  total_teeth_affected: number;
}

interface Props {
  patientId: string;
}

export default function DmftBadge({ patientId }: Props) {
  const [data, setData] = useState<DmftData | null>(null);

  useEffect(() => {
    if (!patientId) return;
    const headers = { Authorization: `Bearer ${getToken()}` };
    axios
      .get(`/api/patients/${patientId}/dmft`, { headers })
      .then((r) => setData(r.data))
      .catch(() => {});
  }, [patientId]);

  if (!data || data.DMFT.score === 0 && data.dmft.score === 0) return null;

  const { DMFT } = data;

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      background: 'linear-gradient(135deg, rgba(139,92,246,0.12), rgba(59,130,246,0.12))',
      borderRadius: 10,
      padding: '4px 12px',
      fontSize: 13,
      fontWeight: 600,
      border: '1px solid rgba(139,92,246,0.2)',
      color: '#4c1d95',
    }}>
      <span style={{ fontSize: 11, opacity: 0.7 }}>DMFT</span>
      <span style={{ color: '#dc2626' }}>{DMFT.decayed}</span>
      <span style={{ opacity: 0.4 }}>/</span>
      <span style={{ color: '#6b7280' }}>{DMFT.missing}</span>
      <span style={{ opacity: 0.4 }}>/</span>
      <span style={{ color: '#059669' }}>{DMFT.filled}</span>
      <span style={{ opacity: 0.4 }}>=</span>
      <span style={{ fontWeight: 700, color: '#1e293b' }}>{DMFT.score}</span>
      {data.dmft.score > 0 && (
        <>
          <span style={{ opacity: 0.3, margin: '0 4px' }}>|</span>
          <span style={{ fontSize: 11, opacity: 0.7 }}>dmft</span>
          <span style={{ fontWeight: 700, color: '#64748b' }}>{data.dmft.score}</span>
        </>
      )}
    </div>
  );
}
